import { render, staticRenderFns } from "./InductionTickets.vue?vue&type=template&id=4c118292&scoped=true"
import script from "./InductionTickets.vue?vue&type=script&lang=js"
export * from "./InductionTickets.vue?vue&type=script&lang=js"
import style0 from "./InductionTickets.vue?vue&type=style&index=0&id=4c118292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c118292",
  null
  
)

export default component.exports